import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from "@tanstack/react-query";
interface PhotoUploadResponse {
  clubSlug: string;
  isFileValid: (file: File) => boolean;
}
export const usePhotoUpload = t0 => {
  const $ = _c(9);
  const {
    clubSlug,
    isFileValid
  } = t0;
  const queryClient = useQueryClient();
  let t1;
  if ($[0] !== clubSlug || $[1] !== isFileValid) {
    t1 = async file => {
      isFileValid(file);
      const formData = new FormData();
      formData.append("file", file);
      const response = await fetch(`/api/club-photos?clubSlug=${clubSlug}`, {
        method: "POST",
        body: formData
      });
      if (!response.ok) {
        throw new Error("Erreur lors de la mise en ligne de la photo");
      }
      const data = await response.json();
      return data;
    };
    $[0] = clubSlug;
    $[1] = isFileValid;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== clubSlug || $[4] !== queryClient) {
    t2 = _data => {
      if (queryClient) {
        queryClient.invalidateQueries({
          queryKey: ["club", clubSlug, "photos"]
        });
      }
    };
    $[3] = clubSlug;
    $[4] = queryClient;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = {
      mutationFn: t1,
      onSuccess: t2,
      onError: _temp
    };
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return useMutation(t3);
};
function _temp(error) {
  console.error(error);
}